module.exports = __webpack_public_path__ + "img/process.560d3ebf.png";